import moment from 'moment';

const dateFormat = (date) => (date ? moment(date).utc().format('DD/MM/YYYY') : '');
const dateFormatWithTime = (date) => (date ? moment(date).utc().format('DD/MM/YYYY HH:mm') : '');

const dateToBr = (date) => (date ? moment(date).utc().format('DD/MM/YYYY') : '');
const dateHourToBr = (date) => (date ? moment(date).utc().format('DD/MM/YYYY - HH:mm') : '');
const hourToBr = (date) => (date ? moment(date).utc().format('HH:mm:ss') : '');
const diffDateDays = (start, end, limit) => {
  const dateStart = moment(start);
  const dateEnd = moment(end);
  const duration = moment.duration(dateEnd.diff(dateStart));
  const days = duration.asDays();
  return days > limit;
};

const selectAllDates = (dateIni, dateEnd) => {
  if ((dateIni !== '' && dateEnd === '') || (dateIni === '' && dateEnd !== '')) {
    return true;
  }
  return false;
};

const getDiffDates = (_start, _end, type) => {
  const start = moment(_start);
  const end = moment(_end);
  return end.diff(start, type);
};

export {
  dateFormat,
  dateFormatWithTime,
  dateToBr,
  dateHourToBr,
  hourToBr,
  diffDateDays,
  selectAllDates,
  getDiffDates,
};
